// How far does a user need to scroll for the page-load header to transition
export const scrollTopThreshold = 50;
